// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { getIsRecentlyPurchasedPage } from "@pacific/App/Store/Selectors/GeneralSelectors";
import cloneDeep from "lodash/cloneDeep";
import qs from "qs";

type HandlerType = HandlerWithResult<{}, string>;

export const XngSetFilterQuery: typeof SetFilterQuery = props => {
    const queryObject = cloneDeep(props.getState().pages.productList.productFilters);
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    if (queryObject.searchWithinQueries && queryObject.searchWithinQueries.length > 1) {
        // Search within Queries need to split by space, to use for ElasticSearch
        queryObject.searchWithinQueries = [queryObject.searchWithinQueries.join(" ")];
    }
    // XNG-Changes: this is to prvent adding previouslyPurchasedProducts to url query string
    if (getIsRecentlyPurchasedPage(props.getState())) {
        delete queryObject.previouslyPurchasedProducts;
    }

    props.result = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });
};
replaceInChain(chain, SetFilterQuery, XngSetFilterQuery);
